import { Outlet } from "react-router-dom";

export function AuthLayout() {
  return (
    <div className="flex min-h-dvh lg:min-h-svh items-center justify-center bg-background p-4">
      <div className="w-full max-w-md animate-fade-in-scale">
        <Outlet />
      </div>
    </div>
  );
}
